module.exports = __webpack_public_path__ + "img/SO.2af110c5.png";